import { NgRedux } from '@ptl/angular-redux-store';
import { Pipe, PipeTransform } from '@angular/core';
import { StateStructure } from '@ptl/state';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { PlansStateStructure } from '../../configs/interfaces/plansStateStructure.interface';
import { PlanAttributes, SummaryView } from '../../interfaces/plan-attributes.interface';
import { Product } from '../../interfaces/product.interface';
import { PlanSummaryListPaginatorStateStructure } from '../../plan-summary-list-paginator/configs/interfaces/plan-summary-list-paginator.state.interface';
import { PLAN_SUMMARY_LIST_PAGINATOR, setTotalLength } from '../../plan-summary-list-paginator/configs/plan-summary-list-paginator.reducer';
import { ActiveFilterMap, PlanFilterStateStructure } from '../configs/reducers/interfaces/plan-filter.state.interface';
import { PLAN_FILTER_REDUCER } from '../configs/reducers/plan-filter.reducer';
import { PRODUCT_GROUPS } from 'src/app/angular-elements/plan-selection/enums/product-groups.enum';

@Pipe({
    name: 'planFilter',
    pure: false,
    standalone: false
})
export class PlanAttributeFilterPipe implements PipeTransform {

  constructor(
    private ngRedux: NgRedux<StateStructure>,
    private reducerUtilityService: ReducerUtilityService
  ) { }

  transform(
    products: Product<PlanAttributes, SummaryView>[],
    activeProductGroup: PRODUCT_GROUPS,
    ...args: unknown[]
  ): Product<PlanAttributes, SummaryView>[] {

    if (!products) { return []; }

    const activeFilters: ActiveFilterMap
      = ( this.reducerUtilityService.getState(PLAN_FILTER_REDUCER) as PlanFilterStateStructure ).activeFilters;

    /** If no filters are enabled, just return everything */
    let someFilterEnabled = false;
    /** If some filters are non-selected, return nothing */
    let filterEmpty = false;
    for (const attr in activeFilters) {
      if (activeFilters[attr].length > 0) {
        someFilterEnabled = true;
      } else {
        filterEmpty = true;
      }
    }

    let filteredProducts: Product<PlanAttributes, SummaryView>[] = null;

    /** No filters */
    if (!someFilterEnabled) { filteredProducts = products; }
    /** Some filters, but one filter is completely unchecked */
    else if (filterEmpty) { filteredProducts = []; }
    /** Some filters, all filters have at least 1 checked */
    else {

      /** Some filters are enabled... */
      filteredProducts = products.filter( product => {

      let allFiltersMatched = true;
      for (const attr in activeFilters) {

        /** Filter has values, Product has attribute */
        if (product.attributes[attr] && activeFilters[attr].length > 0) {

          let exactMatchForCurrentFilter = false;

          /** Filter enabled, attribute is exact match - filter-in */
          for (const key in activeFilters[attr]) {
            if (activeFilters[attr][key].value === product.attributes[attr]) {
              exactMatchForCurrentFilter = true;
            }
          }

          if (!exactMatchForCurrentFilter) {
            allFiltersMatched = false;
          }

        }
      }

      /** Couldn't filter out, matches filter */
      return allFiltersMatched;

    });

    }

    this.dispatchEventIfLengthsDifferent(filteredProducts && filteredProducts.length, activeProductGroup);

    return filteredProducts;
  }

  /* UNUSED
  transformBasedOnPriceFilter(
    min: any,
    max: any,
    products: Product<PlanAttributes, SummaryView>[]
  ) : Product<PlanAttributes, SummaryView>[]{
    const filteredProducts = products.filter( product => {
      return min <= product.price && product.price <= max;
    });

    this.dispatchEventIfLengthsDifferent(filteredProducts && filteredProducts.length, activeProductGroup);

    return filteredProducts;
  }
  */
  get stateStoredFilteredLength() {
    const paginatorState: PlanSummaryListPaginatorStateStructure = this.reducerUtilityService.getState(PLAN_SUMMARY_LIST_PAGINATOR);
    return paginatorState.totalLength;
  }

  get activeProductGroup() {
    const planState: PlansStateStructure = this.reducerUtilityService.getState('Plans');
    return planState.activeProductGroup;
  }

  /** The filter runs against the UI, this will prevent a ton of extra dispatched events */
  dispatchEventIfLengthsDifferent(filteredProductsLength: number, activeProductGroup: PRODUCT_GROUPS) {
    if (!(this.activeProductGroup === activeProductGroup)) { return; }
    if (this.stateStoredFilteredLength !== filteredProductsLength) {
      this.ngRedux.dispatch(setTotalLength(filteredProductsLength));
    }
  }
}
